import { useDungeonEditorStore } from '@/store/dungeonEditorStore';

export function DungeonOverviewPanel() {
  const meta = useDungeonEditorStore((s) => s.meta);
  const mapData = useDungeonEditorStore((s) => s.mapData);
  const updateMeta = useDungeonEditorStore((s) => s.updateMeta);

  if (!meta) {
    return (
      <div className="text-xs text-gray-500 italic">No dungeon loaded.</div>
    );
  }

  const labelClass = 'block text-xs text-gray-500 uppercase tracking-wide mb-1';
  const inputClass = 'w-full px-2 py-1.5 bg-gray-950 border border-gray-700 rounded text-sm text-gray-100';

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-sm font-semibold text-gray-200 mb-3">Dungeon Overview</h2>
      </div>

      <div>
        <label className={labelClass}>Name</label>
        <input
          type="text"
          className={inputClass}
          value={meta.name}
          onChange={(e) => updateMeta({ name: e.target.value })}
        />
      </div>

      <div>
        <label className={labelClass}>Description</label>
        <textarea
          className={`${inputClass} resize-none`}
          rows={3}
          value={meta.description}
          onChange={(e) => updateMeta({ description: e.target.value })}
        />
      </div>

      <div>
        <label className={labelClass}>Theme</label>
        <select
          className={inputClass}
          value={meta.theme}
          onChange={(e) => updateMeta({ theme: e.target.value })}
        >
          <option value="fortress">Fortress</option>
          <option value="crypt">Crypt</option>
          <option value="lair">Lair</option>
          <option value="ruins">Ruins</option>
          <option value="sewer">Sewer</option>
        </select>
      </div>

      <div>
        <label className={labelClass}>Stats</label>
        <div className="grid grid-cols-2 gap-1.5">
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Rooms</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.rooms.length}</div>
          </div>
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Corridors</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.corridors.length}</div>
          </div>
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Entities</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.entities.length}</div>
          </div>
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Triggers</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.triggers.length}</div>
          </div>
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Quests</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.quests.length}</div>
          </div>
          <div className="bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
            <div className="text-xs text-gray-500">Grid</div>
            <div className="text-sm font-semibold text-gray-100">{mapData.gridWidth} x {mapData.gridHeight}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
